import { render, staticRenderFns } from "./FacultySelectboxTransfer.vue?vue&type=template&id=0cc8c293"
import script from "./FacultySelectboxTransfer.vue?vue&type=script&lang=js"
export * from "./FacultySelectboxTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports